import {
  Button,
  ButtonGroup,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Card,
  CardContent,
  List,
  ListItem,
  Tooltip,
  Paper,
  Switch,
  FormControlLabel,
  Typography,
  MenuItem,
  Select,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useEffect, useState } from "react";
import ResponsiveDrawer from "../components/ClippedResponsiveDrawer";
import { getMicrosoftAuth } from "../utils/GetAuth";
import GetBuildInfo from "../utils/GetBuildInfo";
import { useMsal } from "@azure/msal-react";
import requestMissingContexts, {
  determineConfig,
  determineConfigLong,
} from "../utils/GetContext";
import { 
  ExpandMore,
  Help,
  ChevronRight,
 } from "@mui/icons-material";
import { useLocalStorage } from "../componentUtils/LocalStorage";
import { getSalesOffices } from "../utils/GetAdminSettings";
import { checkForRole } from "../utils/GetAuth";
import { getSettingsData,saveSettingsData} from "../utils/GetSettingsData";
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    rootContainer: {
      [theme.breakpoints.down("md")]: {
        padding: 0,
        paddingTop: theme.spacing(1),
      },
    },
    tokenBlock: {
      width: "500px",
      overflowWrap: "break-word",
    },
    typography: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
    centerDiv: {
      textAlign: "center",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
      borderStyle: "none",
      boxShadow: "none"
    },
    cards:{
      borderWidth: "0px",
      border: "none",
      borderStyle: "none",
      boxShadow: "none"
    },
    gridMarginTop: {},
    modalInput: {
      width: "350px",
    },
  })
);

export function SettingsPage() {
  const { instance, accounts, inProgress } = useMsal();
  const classes = useStyles();
  const [authState, setAuthState] = useState("");

  const [Mode, setMode] = useState(false)
  const [darkMode, setDarkMode] = useLocalStorage("SETTINGS.darkmode", false);
  const [salesOffices, setSalesOffices] = useState<any>();
  const [buildState, setBuildState] = useState<any>({});
  const userAccess = JSON.parse(
    window.localStorage.getItem("SETTINGS.userAccess") || "{}"
  );
  const [doneLoading, setDoneLoading] = useState<boolean>();
  const [codes, setCodes] = useState<any>();
  const [compact, setCompact] = useLocalStorage("SETTINGS.compact", true);
  const [defaultSalesOffice, setDefaultSalesOffice] = useLocalStorage(
    "SETTINGS.defaultSalesOffice",
    ""
  );
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "4100");

  useEffect(() => {
  if (doneLoading) return;
  if(salesOrg){
    getSettingsData(salesOrg).then((v) => {
     for (let i=0;i<v?.data?.length;i++){
     if(v?.data[i]?.colKey === 'defaultSalesOffice'){
       setDefaultSalesOffice(v?.data[i]?.colVal);
     }
     if(v?.data[i]?.colKey === 'SETTINGS.darkmode'){
      if(v?.data[i]?.colVal=='true'){
        setMode(true)
        setDarkMode(true);
      }
      else{
        setMode(false);
        setDarkMode(false);
      } 
   
    }
    }
  });
  }
}, [doneLoading]);

  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["SALESORGS", "auth_roles"])
      .then((v) => {
        setCodes(v);
      })
      .then((_) => {
        GetBuildInfo().then((v: any) => {
          setDoneLoading(true);
          setBuildState(v);
        });
      });
  }, [doneLoading]);
  useEffect(() => {
    getSalesOffices(salesOrg).then((v) => {
      setSalesOffices(v);
      setDoneLoading(true);
    });
  }, []);

  const saveSettings=(colKey:any,darkMode:any)=>{
    saveSettingsData(salesOrg,colKey,darkMode?'false':'true').then((v) => {
      setDarkMode(!darkMode);
      setDoneLoading(false);
      window.location.reload();
      });

  }

  return (
    <ResponsiveDrawer
      title="Settings"
    >
      <div className={classes.rootContainer}>
        <Paper className={classes.root}>
          <Grid container spacing={2} className={classes.gridMarginTop}>
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              className={classes.gridSpaceable}
            >
              <Card className={classes.cards}>
                <CardContent>
                  <Typography variant="h5" className={classes.typography}>
                    User Settings
                  </Typography>
                  <Grid 
                    container
                  >
                    <Grid
                      item
                      xs={6}
                      md={4}
                      lg={2}
                      className={classes.gridSpaceable}
                    >
                      <List>
                        <ListItem>
                          <Tooltip title="Switch between dark and light theme for the application.">
                            <FormControlLabel
                              label="Dark Mode"
                              control={
                                <Switch
                                  checked={Mode}
                                  onClick={() => {
                                    saveSettings('SETTINGS.darkmode',darkMode)
                                   
                                  }}
                                />
                              }
                            />
                          </Tooltip>
                        </ListItem>
                        <ListItem>
                          <Tooltip title="Tables display tigter together to see more data on the screen.">
                            <FormControlLabel
                              label="Compact Tables"
                              control={
                                <Switch
                                  checked={compact}
                                  onClick={() => {
                                    setCompact(!compact);
                                    setDoneLoading(false);
                                    window.location.reload();
                                  }}
                                />
                              }
                            />
                          </Tooltip>
                        </ListItem>
                      </List>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      md={4}
                      lg={2}
                      className={classes.gridSpaceable}
                    >
                      <List>
                        <ListItem>
                          <div>
                            <Tooltip title="Default Sales office. Will be prepopulated into filter options when opening pages. You can still change to a different sales office.">
                              <div> Default Sales Office </div>
                            </Tooltip>
                            <Select
                              label="Sales Office"
                              required
                              placeholder="Sales Office"
                              value={defaultSalesOffice}
                              inputProps={{ name: "Sales Office" }}
                              className={classes.modalInput}
                              onChange={(e) => {
                                setDefaultSalesOffice(
                                  e.target.value &&
                                    typeof e.target.value == "string"
                                    ? e.target.value
                                    : ""
                                );

                               const colKey = 'defaultSalesOffice';
                               if(salesOrg){
                               saveSettingsData(salesOrg,colKey,(e.target?.value &&
                                typeof e.target?.value == "string"
                                ? e.target.value
                                : "")).then((v) => {
                                  //console.log(v);
                                });
                              }
                              }}
                            >
                              <MenuItem
                                key=""
                                value=""
                              >{`No Default`}</MenuItem>
                              {salesOffices ? (
                                Object.entries(salesOffices).map(
                                  (so: any, i: number) => (
                                    <MenuItem
                                      key={so[1].code}
                                      value={so[1].code}
                                    >
                                      {so[1].code + " - " + so[1].text_long}
                                    </MenuItem>
                                  )
                                )
                              ) : (
                                <div></div>
                              )}
                            </Select>
                          </div>
                        </ListItem>
                      </List>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Divider />
          <Grid container spacing={2} className={classes.gridMarginTop}>
            <Grid item xs={12} md={6} lg={4} className={classes.gridSpaceable}>
              <Card className={classes.cards}>
                <CardContent>
                  <Typography variant="h5" className={classes.typography}>
                    Clear Local Lookups
                  </Typography>
                  <Typography className={classes.typography}>
                    This will clear text lookups stored locally. Use this if
                    things like materials or trade channels have wrong naming
                    displaying.
                  </Typography>
                  <div className={classes.centerDiv}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        localStorage.removeItem("context-keys");
                        window.location.reload();
                      }}
                    >
                      Clear Lookups
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6} className={classes.gridSpaceable}>
              <Card className={classes.cards}>
                <CardContent>
                  <Typography variant="h5" className={classes.typography}>
                    Clear All Cookies
                  </Typography>
                  <Typography className={classes.typography}>
                    This will clear all offline data. Use this if the{" "}
                    <strong>"Clear Lookups"</strong> button does not fix your
                    issue. The application will forget everything stored
                    locally, this includes your column ordering and default
                    filter settings. You may need to log into the application
                    again.
                  </Typography>
                  <div className={classes.centerDiv}>
                    <Tooltip title="Only use this if you are having issues with the application.">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          localStorage.clear();
                          window.location.reload();
                        }}
                      >
                        Clear Cookies
                      </Button>
                    </Tooltip>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Divider />
          <Grid container spacing={2} className={classes.gridMarginTop}>
            <Grid
              item
              xs={12}
              md={8}
              lg={6}
              xl={4}
              className={classes.gridSpaceable}
            >
              <Card className={classes.cards}>
                <CardContent>
                  <Typography variant="h5" className={classes.typography}>
                    Build Information
                  </Typography>
                  {buildState && Object.keys(buildState).length > 0 ? (
                    <div>
                      <TreeView
                        className={classes.root}
                        defaultCollapseIcon={<ExpandMore />}
                        defaultExpandIcon={<ChevronRight />}
                        defaultExpanded={["1", "2"]}
                      >
                        <TreeItem nodeId="1" label="Application">
                          {Object.entries(buildState.app).map(
                            (v: any, i: number) => (
                              <TreeItem
                                nodeId={v[0]}
                                label={v[0] + " - " + v[1]}
                              />
                            )
                          )}
                        </TreeItem>
                        <TreeItem nodeId="2" label="Database">
                          {Object.entries(buildState.db).map(
                            (v: any, i: number) => (
                              <TreeItem
                                nodeId={v[0]}
                                label={v[0] + " - " + v[1]}
                              />
                            )
                          )}
                        </TreeItem>
                      </TreeView>
                    </div>
                  ) : (
                    <div className={classes.centerDiv}>
                      <CircularProgress color="primary" />
                    </div>
                  )}
                </CardContent>
              </Card>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              lg={6}
              xl={4}
              className={classes.gridSpaceable}
            >
              <Card className={classes.cards}>
                <CardContent>
                  <Typography variant="h5" className={classes.typography}>
                    Current Access Roles
                  </Typography>
                  {userAccess && Object.keys(userAccess).length > 0 ? (
                    <TreeView
                      className={classes.root}
                      defaultCollapseIcon={<ExpandMore />}
                      defaultExpandIcon={<ChevronRight />}
                      defaultExpanded={[Object.keys(userAccess)[0]]}
                    >
                      {Object.entries(userAccess).map(
                        (client: any, i: number) => (
                          <TreeItem nodeId={client[0]} label={client[0]}>
                            {Object.entries(client[1]).map(
                              (sorg: any, i: number) => (
                                <TreeItem
                                  nodeId={sorg[0]}
                                  label={`${sorg[0]} - ${determineConfig(
                                    codes,
                                    "SALESORGS",
                                    sorg[0]
                                  )}`}
                                >
                                  {Object.entries(sorg[1]).map(
                                    (role: any, i: number) => (
                                      <TreeItem
                                        nodeId={role[1]}
                                        label={`${role[1]} (${determineConfig(
                                          codes,
                                          "auth_roles",
                                          role[1]
                                        )})`}
                                      />
                                    )
                                  )}
                                </TreeItem>
                              )
                            )}
                          </TreeItem>
                        )
                      )}
                    </TreeView>
                  ) : (
                    <div className={classes.centerDiv}>
                      <CircularProgress color="primary" />
                    </div>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          {checkForRole(clientId, salesOrg, "cona_internal_dev") ? (
            <div>
              <Divider />
              <Typography variant="h5" className={classes.typography}>
                Experimental
              </Typography>
              <ButtonGroup>
                {authState.length < 1 && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      getMicrosoftAuth(instance, accounts).then((v) => {
                        v && setAuthState(v);
                      })
                    }
                  >
                    Get API Token
                  </Button>
                )}
                {authState.length > 1 && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigator.clipboard.writeText(authState)}
                  >
                    Copy Token
                  </Button>
                )}
              </ButtonGroup>
            </div>
          ) : (
            <div></div>
          )}
        </Paper>
      </div>
    </ResponsiveDrawer>
  );
}
